import React, { useState, useEffect, Fragment, useCallback } from 'react';
import { useForm, Controller } from "react-hook-form";
import TextField from '@mui/material/TextField';
import NativeSelect from '@mui/material/NativeSelect';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import {
    DataGrid, GridToolbarContainer,
    GridToolbarExport,
    gridClasses,
} from '@mui/x-data-grid';
import { yupResolver } from '@hookform/resolvers/yup';
import { PayCard } from './payment'
import * as yup from "yup";
import moment from 'moment';
import DatePicker from '@mui/lab/DatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { Routes, Route, useNavigate, useLocation, useParams } from 'react-router-dom'
import AuthProvider from '../Authentication/authProvider'
import NumberFormat from 'react-number-format';
import { CreateTieDown, GetCompany, GetTieDowns } from '../../REST/invoices'
import Access from '../../Utils/authorize';
import { GetSystemSettings  } from '../../REST/utilities';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import CardActions from '@mui/material/CardActions';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import PageShell from '../../themes/components/PageShell';
import PageHeader from '../../themes/components/PageHeader';
import PageContent from '../../themes/components/PageContent';
import Action from '../../themes/components/Action';
import ResponsiveDataGrid from '../../themes/components/ResponsiveDataGrid';
import Form from '../../themes/components/Form';
import FormActions from '../../themes/components/FormActions';
import FormSection from '../../themes/components/FormSection';
import Grid from '@mui/material/Grid';

const phoneRegExp = /^(\s*|\d+)$/
const gridDateComparator = (a,b)=>{

    return new Date(a) - new Date(b)
}
function CustomToolbar() {
    return (
        <GridToolbarContainer className={gridClasses.toolbarContainer}>
            <GridToolbarExport />
        </GridToolbarContainer>
    );
}
const  TiedownComplete = ({data })=>{
    const navigate = useNavigate()
    const duration = new Date(data.beginDate).toLocaleDateString()+" to "+new Date(data.endDate).toLocaleDateString()
    const name = data.firstName+" "+data.lastName+" "
    return (
        <Card sx={{ minWidth: 400 }}>
            <Box sx={{
                background: 'linear-gradient(135deg, #7e57c2 0%, #673ab7 45%, #4f2ca3 100%)',
                px: 1, py: 0.5,
                display: 'flex', justifyContent: 'flex-end'
            }}>
                <IconButton onClick={() => navigate(-1)} sx={{ color: '#fff' }}>
                    <CloseIcon />
                </IconButton>
            </Box>
        <CardContent>
          <Typography variant="h4" component="h4" style={{textAlign:'center'}}>
                Successfully Submitted
          </Typography>
          <List sx={{ width: '100%',  bgcolor: 'background.paper' }}>
          <ListItem>
                <ListItemText primary={"Name"} secondary={name} />
             </ListItem>
             <ListItem>
                <ListItemText primary={"Phone #"} secondary={data.phone} />
             </ListItem>
             <ListItem>
                <ListItemText primary={"Email"} secondary={data.email} />
             </ListItem>
            <ListItem>
                <ListItemText primary={"Aircraft Type"} secondary={data.airCraftType} />
             </ListItem>
             <ListItem>
                <ListItemText primary={"Aircraft Number"} secondary={data.airCraftNum} />
             </ListItem>
             <ListItem>
                <ListItemText primary={"Vehicle Number"} secondary={data.space} />
             </ListItem>
             <ListItem>
                <ListItemText primary="Duration" secondary={duration} />
             </ListItem>
             {
                data.amount > 0  &&
                (
                  <ListItem>
                    <ListItemText primary="Paid amount" secondary={data.amount} />
                 </ListItem>  
                )

             }
            
          </List>
        </CardContent>
      </Card>
         

    )

}
export default function TieDown() {

    const location = useLocation()


    return <Fragment>
        {location.pathname === '/tiedown' && <TieDownList />}
        <Routes>
            <Route path='create' element={<CreateTieDownView />} />
            <Route path=':id' element={<AuthProvider><ViewTieDown /></AuthProvider>} />
        </Routes>
    </Fragment>
}

function TieDownList() {
    const navigate = useNavigate()

    const getDate = (date) => {
        return new Date(date).toLocaleDateString()
    }
 
    const columns = [
        { field: 'fullName', headerName: 'Name', flex: 0.6, minVisible: 'xs', valueGetter: (params) => `${params.row.firstName || ''} ${params.row.lastName || ''}`.trim()},
        { field: 'email', headerName: 'Email', flex: 0.5, minVisible: 'md' },
        { field: 'phone', headerName: 'Phone #', flex: 0.5, minVisible: 'md' },
        { field: 'beginDate', headerName: 'Arrival Date', type: 'date', sortComparator:gridDateComparator, flex: 0.5, minVisible: 'lg', valueGetter: (p) => getDate(p.row.beginDate) },
        { field: 'endDate', headerName: 'Departure Date', type: 'date', sortComparator:gridDateComparator, flex: 0.5, minVisible: 'lg', valueGetter: (p) => getDate(p.row.endDate) },
        { field: 'airCraftType', headerName: 'Aircraft Type', flex: 0.5, minVisible: 'lg' },
        { field: 'airCraftNum', headerName: 'Aircraft Number', flex: 0.5, minVisible: 'lg' },
        { field: 'space', headerName: 'Vehicle #', flex: 0.5, minVisible: 'md' },
        {field: 'amount', headerName: 'Amount', type: 'number',flex: 0.4,minVisible: 'md',
            renderCell: (params) => {
                return <NumberFormat value={params.row.amount} displayType={'text'} thousandSeparator={true} prefix={'$'} />
            }
        },
        {
            field: 'invoice', headerName: 'Invoice', width: 120, minVisible: 'xs',
            renderCell: (params) => {
                return <Button size="small" onClick={() => navigate('/Invoices/' + params.row.invoice)}>View Invoice</Button>
            }
        }
    ];

    const fetchTieDowns = useCallback(async (page, limit, filters, sort) => {
        const params = {
            page,
            limit
        }
        
        if (Object.keys(filters).length > 0) {
            params.filters = JSON.stringify(filters)
        }
        
        if (sort) {
            params.sort = JSON.stringify(sort)
        }
        
        const result = await GetTieDowns(params);

        if (result.data?.data) {
            const transformed = result.data.data.map(e => ({
                ...e,
                id: e._id
            }));
            return {
                data: transformed,
                pagination: result.data.pagination
            };
        }

        if (Array.isArray(result.data)) {
            const transformed = result.data.map(e => ({ ...e, id: e._id }));
            return {
                data: transformed,
                pagination: { total: transformed.length, page: 1, totalPages: 1 }
            };
        }

        return { data: [], pagination: { total: 0, page: 1, totalPages: 0 } };
    }, [])


    return (
        <PageShell>
            <PageHeader
                title="Transient & Landing Fees"
                back
                onBack={() => navigate('/')}
                actions={
                    <Action
                        primary
                        icon={<AddIcon />}
                        label="Add Transient & Landing Fee"
                        onClick={() => navigate('/Tiedown/Create')}
                    />
                }
            />

            <PageContent fill>
                <ResponsiveDataGrid
                    columns={columns}
                    fetchData={fetchTieDowns}
                    initialPageSize={10}
                    pageSizeOptions={[10, 25, 50, 100]}
                    clientSort={{ field: 'firstName', order: 'asc' }}
                />
            </PageContent>
        </PageShell>
    );
}

function ViewTieDown() {
    const { id } = useParams()
    return <p>View {id}</p>
}

function CreateTieDownView() {
    const [data, setData] = useState(null)
    const [tenant, setTenant] = useState(null)
    const [pay, setPay] = useState(true)
    const [done, setDone] = useState(null)
    const navigate = useNavigate()

    useEffect(() => {
        const user = Access.user()
        if (user) {
            (async () => {
                const company = await GetCompany(user)
                setTenant(company.companyId)
            })()
        }
    }, [])
    useEffect(()=>{
        GetSystemSettings().then((result)=>{
            const setting = result.data.find((x)=>{ return x.name == "TIEDOWN_PAYMENT"} )
            if(setting) setPay( setting.value == "true")

        })
    },[])
    const schema = yup.object({
        firstName: yup.string().trim(),
        lastName: yup.string().trim(),
        businessName: yup.string().trim(),
        beginDate: yup.date().required(),
        endDate: yup.date().nullable().transform((v) => (v instanceof Date && !isNaN(v) ? v : null)),
        airCraftType: yup.string().trim(),
        airCraftNum: yup.string().trim().required(),
        space: yup.string().trim(),
        email: yup.string().email(),
        phone: yup.string().trim().matches(phoneRegExp, { message: 'Phone number is not valid', excludeEmptyString: true })
    }).required();

    const user = Access.getUser()

    console.log(user)

    const methods = useForm({
        defaultValues: {
            firstName: user ? user.given_name : '',
            lastName: user ? user.family_name : '',
            businessName: '',
            beginDate: new Date().toISOString(),
            endDate: '',
            airCraftType: '',
            airCraftNum: '',
            space: '',
            email:'',phone:''
        },
        resolver: yupResolver(schema)
    });
    const { control, formState: { errors }, clearErrors, reset } = methods;

    useEffect(() => {
        clearErrors()
        reset()
    }, [clearErrors, reset])

    const onSubmit = async (result) => {
        setData(result)
    }

    const isError = (val) => val !== undefined && val !== null && typeof val === 'object'

    const getOptions = () => {
        const types = ['Single and Multi-Engine Piston', 'Multi-Engine Turboprop', 'Small Jet', 'Medium Jet 1', 'Medium Jet 2', 'Large Jet']
        return [<option key={'NA'}> Select One</option>].concat(types.map(e => {
            return <option key={e} value={e} > {e}</option>
        }))
    }
    const onSubmitNoPay = async (result)=>{
        const receipt = {}
        const resp = await CreateTieDown(tenant, { receipt, tiedown: { ...result, amount: 0 } })
        setDone(resp.data)
    }

   if (done  != null )
   {

        if(user != null)
        {
            navigate('/tiedown', { replace: true }) 
            return null
        }
        else
        {
            return (
            <div className="row">
                <div className="col-3"></div> 
                <div className="col-6">
                    <TiedownComplete data={done} ></TiedownComplete>
                </div>
            </div>      
            )
        }
       
   }

    return (
        <PageShell>
            <PageHeader
                title="Create Transient & Landing Fee"
                back
                onBack={() => navigate(-1)}
            />
            <PageContent sx={{ p: { xs: 2, md: 3 } }}>
                <Form methods={methods} onSubmit={pay ? onSubmit : onSubmitNoPay}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        {data === null && (
                            <>
                                <FormSection title="Pilot Information">
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <Controller name="firstName" control={control} render={({ field }) => <TextField size='small' margin='dense' error={isError(errors.firstName)} helperText={errors.firstName?.message} fullWidth label='First Name' {...field} />} />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Controller name="lastName" control={control} render={({ field }) => <TextField size='small' margin='dense' error={isError(errors.lastName)} helperText={errors.lastName?.message} fullWidth label='Last Name' {...field} />} />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Controller name="businessName" control={control} render={({ field }) => <TextField size='small' margin='dense' error={isError(errors.businessName)} helperText={errors.businessName?.message} fullWidth label='Business Name' {...field} />} />
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            <Controller name="phone" control={control} render={({ field }) => <TextField size='small' margin='dense' error={isError(errors.phone)} helperText={errors.phone?.message} fullWidth label='Phone' {...field} />} />
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            <Controller name="email" control={control} render={({ field }) => <TextField size='small' margin='dense' error={isError(errors.email)} helperText={errors.email?.message} fullWidth label='Email' {...field} />} />
                                        </Grid>
                                    </Grid>
                                </FormSection>

                                <FormSection title="Flight Details" divider>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <Controller name="beginDate" control={control} render={({ field }) =>
                                                <DatePicker label='Arrival Date'
                                                    renderInput={(params) => <TextField size='small' margin='dense' required fullWidth {...params} error={isError(errors.beginDate)} helperText={errors.beginDate?.message} onChange={field.onChange} />}
                                                    {...field} />
                                            } />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Controller name="endDate" control={control} render={({ field }) =>
                                                <DatePicker label='Departure Date (estimated)'
                                                    renderInput={(params) => <TextField size='small' margin='dense' fullWidth {...params} error={isError(errors.endDate)} helperText={errors.endDate?.message} onChange={field.onChange} />}
                                                    {...field} />
                                            } />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Controller name="airCraftType" control={control} render={({ field }) =>
                                                <FormControl error={isError(errors.airCraftType)} margin='dense' fullWidth size='small'>
                                                    <InputLabel shrink>Aircraft Type</InputLabel>
                                                    <NativeSelect {...field}>{getOptions()}</NativeSelect>
                                                    {errors.airCraftType && <FormHelperText>{errors.airCraftType.message}</FormHelperText>}
                                                </FormControl>
                                            } />
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            <Controller name="airCraftNum" control={control} render={({ field }) => <TextField size='small' margin='dense' required error={isError(errors.airCraftNum)} helperText={errors.airCraftNum?.message} fullWidth label='Tail Number' {...field} />} />
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            <Controller name="space" control={control} render={({ field }) => <TextField size='small' margin='dense' error={isError(errors.space)} helperText={errors.space?.message} fullWidth label='Vehicle #' {...field} />} />
                                        </Grid>
                                    </Grid>
                                </FormSection>

                                <FormActions>
                                    <Button onClick={() => navigate(-1)}>Cancel</Button>
                                    <Button type="submit" variant='contained'>Submit</Button>
                                </FormActions>
                            </>
                        )}
                        {data !== null && pay && <PayTieDown data={data} company={tenant} />}
                    </LocalizationProvider>
                </Form>
            </PageContent>
        </PageShell>
    )
}

function PayTieDown({ data, company }) {

    const [done, setDone] = useState(null)
    const navigate = useNavigate()
    const user = Access.user()
    const getAmount = () => {
        const days = data.endDate ? Math.abs(moment(data.beginDate).diff(moment(data.endDate), 'days')) : 1
        switch (data.airCraftType.toLowerCase()) {
            case 'Single and Multi-Engine Piston'.toLowerCase():
                return 30 * days
            case 'Multi-Engine Turboprop'.toLowerCase():
                return 80 * days
            case 'Small Jet'.toLowerCase():
                return 30 * days
            case 'Medium Jet 1'.toLowerCase():
                return 30 * days
            case 'Medium Jet 2'.toLowerCase():
                return 50 * days
            case 'Large Jet'.toLowerCase():
                return 80 * days
            default:
                return 0
        }
    }
    
    const handleResult = (receipt) => {
        (async () => {
            const resp = await CreateTieDown(company, { receipt, tiedown: { ...data, amount: getAmount() } })
            
            setDone(resp.data)
        })()

    }

    if (done != null )
    {
        if(user != null)
        {
            navigate('/tiedown', { replace: true }) 
            return null
        }
        else
        {
            return (<TiedownComplete data={done}  ></TiedownComplete>)
        }
    }

    return <React.Fragment>
        <p>The total is calculated based on the aircraft type and the number of nights you will tie-down your aircraft.</p>
        <p>Aircraft type fee:</p>
        <p>Single And Multi-Engine Piston - $30</p>
        <p>Mutli-Engine Turboprop - $80</p>
        <p>Small Jet (upto 16K Lbs) - $30</p>
        <p>Medium Jet 1(16K - 40K Lbs) - $30</p>
        <p>Medium Jet 2(16K - 40K Lbs) - $50</p>
        <p>Large Jet (over 40K Lbs) - $80</p>
        <p>Aircraft Type X Number of Nights = Total.</p>
        <p>To continue to payment, please click submit.</p>

        <h4>Total Amount Due: {<NumberFormat value={getAmount()} displayType={'text'} thousandSeparator={true} prefix={'$'} />}</h4>
        <PayCard onComplete={handleResult} amount={getAmount()} />
    </React.Fragment>

}
